import { Routes } from '@angular/router';
import { WeightReportComponent } from './pages/weight-report.component';

export const gewichtsportalRoutes: Routes = [
  { path: 'gewichtsportal', component: WeightReportComponent }
];
